import { render } from "./speaker.vue?vue&type=template&id=c4271d80"
const script = {}

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__